// public routes.tsx
import { Backdrop, CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, Route } from "react-router-dom";
import { BusinessSelection } from "../pages";
import { BusinessInstance } from "../utils/businessClass";

const SelectBusinessLayout = () => {
  const business = useSelector((state: any) => state.business);

  useEffect(() => {
    fetchBusinesses();
  }, []);

  const fetchBusinesses = async () => {
    await BusinessInstance.initialize();
  };

  if (business.isLoading) {
    return (
      <Backdrop open>
        <CircularProgress
          color="inherit"
          sx={{
            height: 200,
            width: 200,
            position: "absolute",
            top: "calc(vheight/2 -100px)",
          }}
        />
      </Backdrop>
    );
  }

  console.log("bus", business);

  if (business?.id) return null;

  return <Outlet />;
};

export const SelectBusinessRoutes = [
  <Route key="select-business-routes" element={<SelectBusinessLayout />}>
    <Route path="*" element={<BusinessSelection />} />
  </Route>,
];
